import { render, staticRenderFns } from "./manageFrom.vue?vue&type=template&id=0f57debe&scoped=true"
import script from "./manageFrom.vue?vue&type=script&lang=js"
export * from "./manageFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f57debe",
  null
  
)

export default component.exports